import * as angular from 'angular';
import * as _ from 'lodash';
import template from './addRequalification.tpl.html';
import DateUtilityService, {DateTimeRange} from "../../services/utility/dateutility.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import RequalificationServiceName, {RequalificationService} from "../../services/requalification/requalification.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import {apsCommands} from "../../shared/dto/aps.commands";

let requires = [LoaderServiceName, NotifyServiceName, RequalificationServiceName, AuthDataServiceName];

export interface AddRequalificationData {
  shopId: string;
  activity: Activity;
  section: Section;
  gob: Gob;
  date: Date;
}
interface Activity {
  timeZoneId: string;
}
interface Machine {
  id: string;
  sections: Section[];
}
interface Section {
  machine: Machine;
  sectionNumber: number;
  gobs: Gob[];
}
interface Gob {
  section: Section;
  gobNumber: number;
}
interface AddRequalificationCtrl {
  shopId: string;
  activity: Activity;
  gob: Gob;
  section: Section;
  machine: Machine;
  setOut: boolean;
  sections: Section[];
  gobs: Gob[];
  hourRange: DateTimeRange;
  selections: SectionSelection[];
  requalificationDateTime: Date;
  location: number;
  cause: string;
  timeZone: string;
  form: angular.IFormController;
  isSelectionValid(): boolean;
  addRequalification(): void;
  cancel(): void;
}
interface SectionSelection {
  section: Section;
  gobs: GobSelection[];
  selected: boolean;
}
interface GobSelection {
  gob: Gob;
  selected: boolean;
  currentMold(): string;
}

export default angular.module('aps.controller.requalification', requires)
  .controller('AddRequalificationCtrl', addRequalificationCtrl)
  .name;

export function openAddRequalification(data: AddRequalificationData,
                                       $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'AddRequalificationCtrl as vm',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

function addRequalificationCtrl(
  $modalInstance: mm.foundation.modalInstance,
  loaderService: LoaderService,
  notifyService: NotifyService,
  requalificationService: RequalificationService,
  data: AddRequalificationData,
  authDataService: AuthDataService
) {
  var vm = this as AddRequalificationCtrl;
  vm.shopId = data.shopId;
  vm.activity = data.activity;
  vm.gob = data.gob;
  vm.section = vm.gob.section;
  vm.machine = vm.section.machine;
  vm.sections = vm.machine.sections;
  vm.gobs = _.first(vm.sections).gobs;
  vm.timeZone = vm.activity.timeZoneId;

  vm.hourRange = DateUtilityService.getHourRange(data.date, vm.activity.timeZoneId);
  vm.requalificationDateTime = vm.hourRange.initialTime.toDate();

  var getCurrentMold = function (gob) {
    return function () {
      var mold = gob.moldOnDate(vm.requalificationDateTime);
      return mold ? mold.toolNumber : '';
    };
  };
  var selections = [];
  _.forEach(vm.sections, function (section) {
    var sectionSelection: SectionSelection = {
      section: section,
      gobs: [],
      selected: data.section === section
    };
    _.forEach(section.gobs, function (gob) {
      sectionSelection.gobs.push({
        gob: gob,
        currentMold: getCurrentMold(gob),
        selected: data.gob === gob
      });
    });
    selections.push(sectionSelection);
  });
  vm.selections = selections;
  vm.setOut = (vm.gob.gobNumber || 0) <= 0;

  vm.cause = '';

  vm.isSelectionValid = () => {
    if (vm.setOut) {
      return true;
    }

    var result = false;
    _.forEach(vm.selections, function (sectionSelection) {
      if (sectionSelection.selected) {
        result = true;
        return false;
      }

      _.forEach(sectionSelection.gobs, function (gobSelection) {
        if (gobSelection.selected) {
          result = true;
          return false;
        }
      });
    });
    return result;
  };

  vm.addRequalification = function () {

    if (vm.form.$invalid || !vm.isSelectionValid()) {
      return;
    }

    var role = authDataService.getSelectedRoleLocation().role;
    // create command
    var command: apsCommands.AddRequalification = {
      shopId: vm.shopId,
      machineId: vm.machine.id,
      requalificationDateTime: vm.requalificationDateTime,
      location: role.roleLocation,
      cause: vm.cause,
      entireMachine: vm.setOut,
      machineLocations: []
    };

    if (!vm.setOut) {
      _.forEach(vm.selections, function (sectionSelection) {
        if (sectionSelection.selected) {
          command.machineLocations.push({
            id: undefined,
            section: sectionSelection.section.sectionNumber,
            gob: null,
            skip: false
          });
        } else {
          _.forEach(sectionSelection.gobs, function (gobSelection) {
            if (gobSelection.selected) {
              command.machineLocations.push({
                id: undefined,
                section: sectionSelection.section.sectionNumber,
                gob: gobSelection.gob.gobNumber,
                skip: false
              });
            }
          });
        }
      });
    }

    // call the service
    var promise = requalificationService.addRequalification(command)
      .then(function () {
        $modalInstance.close();
      }, notifyService.handleApiErrors);
    loaderService.loadingPromise(promise);
  };

  vm.cancel = function () {
    $modalInstance.close();
  };
}


// WEBPACK FOOTER //
// ./src/app/controllers/requalification/addRequalification.controller.ts